module.exports = __webpack_public_path__ + "static/media/SpikeForest_Long.82b0738b.jpg";